import { FormControlLabel, Radio, styled } from '@mui/material';
import { HelixPalette, HelixStyles } from '../../helix';
/**
 * Styles FormControlLabel for Radio.
 */
export const HelixLabel = styled(FormControlLabel)(() => ({
    margin: 0,
    '.MuiFormControlLabel-label': Object.assign(Object.assign({}, HelixStyles.style_07), { margin: '0 0 0 0.5rem ' }),
    '&.Mui-disabled': {
        '.MuiFormControlLabel-label': {
            color: HelixPalette.neutral90,
        },
    },
}));
/**
 * Styled Radio.
 */
export const HelixRadio = styled(Radio)(({ checked }) => ({
    borderRadius: '100%',
    padding: 0,
    svg: { fill: checked ? HelixPalette.teal80 : HelixPalette.neutral50, transition: 'none' },
    ':hover': {
        svg: { fill: HelixPalette.teal70 },
    },
    ':active:focus': {
        svg: { fill: HelixPalette.teal90 },
    },
    '&.Mui-focusVisible': {
        outline: HelixStyles.focusVisible6.outline,
        outlineOffset: HelixStyles.focusVisible6.outlineOffset,
    },
    '&.Mui-disabled': {
        '&::before': {
            content: '""',
            display: 'block',
            width: '16px',
            height: '16px',
            borderRadius: '50%',
            backgroundColor: HelixPalette.neutral10,
            position: 'absolute',
            top: '4px',
            left: '4px',
        },
        svg: { fill: HelixPalette.neutral50 },
    },
}));
